// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDLeC_4lY0b_FXq7JWXIZLdzc-NpvXdmcY',
    authDomain: 'uwi-park-tracker.firebaseapp.com',
    databaseURL: 'https://uwi-park-tracker.firebaseio.com',
    projectId: 'uwi-park-tracker',
    storageBucket: 'uwi-park-tracker.appspot.com',
    messagingSenderId: '50922408819'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
